import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import MButton from "@/components/atom/MButton";
import globalStyle from "@/styles/Global.scss";
import {getScheduleListOf} from "@/api/schedule";
import {getUketoriTargetUser} from "@/api/exchange";
import _ from "lodash";
import ScheduleView from "@/components/schedule/ScheduleView";
import {rangeOf} from "@/util/util";
import dayjs from "dayjs";
import {Schedule as ScheduleModel} from "@/entity/Schedule";

const UketoriCardSchedulePage = () => {
  const history = useHistory()
  const {id} = useParams()
  const [dateStart, setDateStart] = useState(0)
  const [dateOffset, setDateOffset] = useState(30)
  const [schedules, setSchedules] = useState([])
  const [waUser, setWaUser] = useState(null)

  useEffect(() => {
    (async () => {
      const cardExchangeUser = await getUketoriTargetUser({id})
      const schedules = await getScheduleListOf({userId: cardExchangeUser.id})
      setSchedules(schedules)
      setWaUser(cardExchangeUser)
    })()
  }, [id])

  const toBack = () => {
    history.push(`/uketori/${id}`)
  }

  const todaySchedule = ({offset}) => {
    const targetDate = dayjs().subtract(offset, 'day')
    const formatTargetDate = targetDate.format('YYYY-MM-DD')
    return _.filter(schedules, (s) => { return formatTargetDate === s.formatedDate() })[0]
      || new ScheduleModel({ date: targetDate.toDate() })
  }

  const makeDateOffsets = () => {
    return _.map(rangeOf(dateOffset), (r) => {return r + dateStart})
  }

  const expandOffset = (expand) => {
    if (expand < 0) {
      setDateStart(dateStart + expand)
    }
    setDateOffset(dateOffset + Math.abs(expand))
  }

  return (
    <>
      <Layout category={'UK'} title={'スケジュール'}>
        <div className={globalStyle.container}>
          <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
          <h3>{ waUser && <span>{waUser.fullName()}さんの</span> }スケジュール</h3>
          <div style={{marginBottom: '10px'}}>
            <MButton image={'after30.png'}
                     onClick={() => {
              expandOffset(-30)
            }}/>
          </div>
          {
            _.map(makeDateOffsets(), (offset) => {
              return <React.Fragment key={offset}>
                <ScheduleView schedule={todaySchedule({offset})}></ScheduleView>
              </React.Fragment>
            })
          }
          <MButton image={'before30.png'}
                   onClick={() => {
                     expandOffset(30)
                   }}/>
          <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default UketoriCardSchedulePage
